import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Window } from '../desktopComponents/Window';
import { ICON_FONT_SIZE } from '../../helpers/defaultSizes';
import { useDispatch } from 'react-redux';
import { focusWindow, iconOpenWindow } from '../../redux/ducks/windows';

const SecretPasswordContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  font-size: ${ICON_FONT_SIZE};
`;

const GuessingText = styled.div`
  font-size: ${ICON_FONT_SIZE};
  margin-bottom: 20px;
  color: white;
`;

const EnterPassword = styled.label`
  font-size: ${ICON_FONT_SIZE};
  margin-right: 5px;
  color: white;
`;

const InputPassword = styled.input`
  font-size: ${ICON_FONT_SIZE};
  border: none;
  background: none;
  color: white;

  &:focus {
    outline: none;
  }
`;

export const UnknownPage = (props) => {
  const [secretCode, setSecretCode] = useState('');
  const [entryCounter, setEntryCounter] = useState(0);
  const [firstSubmit, setFirstSubmit] = useState(false);
  const [openSecretWindow, setOpenSecretWindow] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(iconOpenWindow());
    dispatch(focusWindow());
  }, [dispatch]);

  const handleSubmit = (e) => {
    if (
      e.key === 'Enter' &&
      secretCode !== 'supersecretpassword' &&
      secretCode !== ''
    ) {
      setEntryCounter(getRandomInt(9));
      setFirstSubmit(true);
      setSecretCode('');
    } else if (secretCode === 'supersecretpassword') {
      setEntryCounter(9);
      setSecretCode('');
      setFirstSubmit(true);
      setOpenSecretWindow(true);
      dispatch(iconOpenWindow('SECRETROOM'));
      dispatch(focusWindow('SECRETROOM'));
    }
  };

  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  const failureTexts = [
    'guess again',
    'keep trying',
    'nope...',
    'cmon?',
    '...',
    'try again',
    'hint: its not that',
    'hi, from rowan =the dev= (⌐■ ͜ʖ■)',
    'ur bad',
    'wow you actually got it',
  ];

  return (
    <>
      <Window
        title={'404.exe'}
        width={'450px'}
        height={'100px'}
        bgColor={'black'}
      >
        <SecretPasswordContainer>
          <GuessingText>
            {firstSubmit ? failureTexts[entryCounter] : 'Have a guess?'}
          </GuessingText>
          <div>
            <EnterPassword>Enter Password:</EnterPassword>
            <InputPassword
              className="CANCEL_DRAGGABLE"
              placeholder="Password"
              value={secretCode}
              onChange={(e) => setSecretCode(e.target.value)}
              onKeyDown={(e) => handleSubmit(e)}
            ></InputPassword>
          </div>
        </SecretPasswordContainer>
      </Window>
      {openSecretWindow ? (
        <Window
          title={'SECRETROOM'}
          width={'450px'}
          height={'100px'}
          bgColor={'white'}
        >
          <SecretPasswordContainer>
            YOU HAVE BEEN CHOSEN
          </SecretPasswordContainer>
        </Window>
      ) : null}
    </>
  );
};
